import React from "react";
import PropTypes from "prop-types";
import PostPurchaseProductBlock from "../../../../../layouts/checkout-extension/post-purchase/PostPurchaseProductBlock";

/** Checkout / thank-you / order-status compact row — existing extension layout. */
export default function ExtensionCompactLayout({
  popupData,
  section,
  activeStep,
  parentIndex,
  footerContent,
  extensionVariant = "default",
}) {
  return (
    <PostPurchaseProductBlock
      layout="extension"
      extensionVariant={extensionVariant}
      popupData={popupData}
      section={section}
      activeStep={activeStep}
      parentIndex={parentIndex}
      footerContent={footerContent}
    />
  );
}

ExtensionCompactLayout.propTypes = {
  popupData: PropTypes.object,
  section: PropTypes.object,
  activeStep: PropTypes.number,
  parentIndex: PropTypes.number,
  footerContent: PropTypes.node,
  extensionVariant: PropTypes.oneOf(["default", "cart-drawer"]),
};
